import React, { Component } from 'react';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconEdit } from '../../media/icons/edit.svg';
import { ReactComponent as IconWebsite } from '../../media/icons/website.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';


export default class Activity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            data: {},
            picture: 1,
            picture_filepath_base: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/activities/"
        };
        this.setEditing = this.props.setEditing.bind(this);
        this.nextPicture = this.nextPicture.bind(this);
        this.previousPicture = this.previousPicture.bind(this);
        this.setPopup = this.props.setPopup.bind(this);
    }


    componentDidMount() {
        if (this.props.data !== this.state.data) {
            var data = this.props.data;
            data.pictures.forEach((picture, index) => {
                picture.order = index
            });
            this.setState({
                data: data
            });
        }
    }


    componentDidUpdate() {
        if (this.props.data !== this.state.data) {
            var data = this.props.data;
            data.pictures.forEach((picture, index) => {
                picture.order = index
            });
            this.setState({
                data: data
            });
        }
    }


    nextPicture() {
        var picture = this.state.picture + 1 > this.props.data.pictures.length ? 1 : this.state.picture + 1;
        this.setState({
            picture: picture
        });
    }


    previousPicture() {
        var picture = (this.state.picture - 1) < 1 ? this.props.data.pictures.length : this.state.picture - 1;
        this.setState({
            picture: picture
        });
    }


    render() {
        return (
            <div className={"trip__segment__activity"}>
                <div className="trip__segment__activity__content">
                    <div onClick={() => this.props.selectMapMarker(this.props.segment_order * 1000 + this.props.data.order)} className="trip__segment__activity__element trip__segment__activity__label text-bold pointer">
                        {this.props.data.label}
                    </div>

                    {this.props.activity_selected === this.props.segment_order * 1000 + this.props.data.order &&
                        <div className="trip__segment__activity-selected-overlay"></div>
                    }

                    {this.props.owner &&
                        <div className="trip__element__edit-shape"></div>
                    }
                    {this.props.owner &&
                        <IconEdit onClick={() => this.setEditing("activity", this.props.segment_order, this.props.activities_category, this.props.data.order)} className="trip__element__edit-icon" />
                    }

                    {this.props.data.website && this.props.data.website != "" &&
                        <div className="trip__segment__activity__element trip__segment__activity__link-container">
                            <div className="trip__segment__activity__icon">
                                <IconWebsite className="trip__segment__activity__icon-inner" />
                            </div>
                            <a href={(this.props.data.website.startsWith("https://") ? this.props.data.website : "https://" + this.props.data.website)} target="_blank" rel="noopener noreferrer" className="trip__segment__activity__link">
                                {this.props.data.website.length >= 50 ? this.props.data.website.slice(0, 50) + "..." : this.props.data.website}
                            </a>
                        </div>
                    }
                    <div className="trip__segment__activity__element trip__segment__activity__address-container">
                        <div className="trip__segment__activity__icon">
                            <IconLocation className="trip__segment__activity__icon-inner" />
                        </div>
                        <div className="trip__segment__activity__address text-color-grey">
                            {/* (this.props.data.category && this.props.data.category + " | ") +  */(this.props.data.subsubcategory ? this.props.data.subsubcategory : this.props.data.subcategory && this.props.data.subcategory) + (this.props.data.pricing ? " | " + this.props.data.pricing : "")}
                        </div>
                    </div>
                    <div className="trip__segment__activity__element trip__segment__activity__address-container">
                        <div className="trip__segment__activity__icon">
                            <IconLocation className="trip__segment__activity__icon-inner" />
                        </div>
                        <a href={"https://maps.google.com/?q=" + this.props.data.address} target="_blank" rel="noopener noreferrer" className="trip__segment__activity__address text-color-grey">
                            {(this.props.data.city && this.props.data.city + " | ") + this.props.data.address}
                        </a>
                    </div>
                    <div className="trip__segment__activity__element trip__segment__activity__description">
                        {this.props.data.comment}
                    </div>
                </div>

                {this.props.data.pictures.length >= 1 &&
                    <div className={"trip__segment__activity__carousel" + (this.props.data.pictures.length >= 1 ? "" : " hidden")}>

                        <div className="trip__segment__activity__carousel-container">
                            {this.props.data.pictures.map((picture, i) => (
                                <div key={i} className={"trip__segment__activity__carousel__picture" + ((this.state.picture - 1) == picture.order ? "" : " trip__segment__activity__carousel__picture--hidden")}>
                                    {picture.filepath.endsWith(".mp4") ||
                                        picture.filepath.endsWith(".mov") ||
                                        picture.filepath.endsWith(".avi") ? (
                                        <video
                                            src={picture.filepath}
                                            alt={picture.label ? picture.label : this.props.data.label}
                                            className={"trip__segment__activity__carousel__picture-inner"}
                                            autoPlay
                                            muted
                                            loop
                                            preload="auto"
                                        />
                                    ) : (
                                        <img
                                            src={picture.filepath}
                                            alt={picture.label ? picture.label : this.props.data.label}
                                            className={"trip__segment__activity__carousel__picture-inner"}
                                        />
                                    )
                                    }
                                </div>
                            ))}
                        </div>

                        {this.props.data.pictures.length >= 1 &&
                            <div className="trip__segment__activity__carousel__indicator-container">
                                <div onClick={() => this.setPopup("pictures", this.props.segment_order, this.props.data.order)} className="trip__segment__activity__carousel__indicator text-bold">
                                    {/* {(this.state.picture) + "/" + this.props.data.pictures.length} */}
                                    See all
                                </div>
                            </div>
                        }
                        {this.props.data.pictures.length >= 2 &&
                            <div onClick={this.previousPicture} className="trip__segment__activity__carousel__button trip__segment__activity__carousel__button--left">
                                <IconArrow className="trip__segment__activity__carousel__button-inner trip__segment__activity__carousel__button-inner--left" />
                            </div>
                        }
                        {this.props.data.pictures.length >= 2 &&
                            <div onClick={this.nextPicture} className="trip__segment__activity__carousel__button trip__segment__activity__carousel__button--right">
                                <IconArrow className="trip__segment__activity__carousel__button-inner trip__segment__activity__carousel__button-inner--right" />
                            </div>
                        }
                    </div>
                }

                {(this.props.data.pictures.length < 1) &&
                    <div className={"trip__segment__activity__carousel"}>
                        <div className="trip__segment__activity__carousel-container">
                        <div className="trip__segment__activity__carousel__picture">
                            <img src={this.state.picture_filepath_base + (this.props.data.subcategory == "Other" ? this.props.data.category.toLowerCase() + "_" + this.props.data.subcategory.toLowerCase() + ".webp" : this.props.data.subcategory.toLowerCase().replace(" ", "+") + ".webp")} alt={this.props.data.subcategory} className={"trip__segment__activity__carousel__picture-inner"} />
                        </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}
